import {FlowComponentIcons, WSPIcons} from '@mintdata-wsp/resources/icons/WSPIcons';

const FlowIcons:FlowComponentIcons = WSPIcons.visualDesigner.components.flow;

export class FlowIconsMap
{
    public static readonly DEFAULT_ICON = FlowIcons.DefaultFlowIcon;

    public static readonly ArtifactToIconsMap =
    {
        'mintdata.components:io-components:0.3.0-SNAPSHOT':
            {
                // Notifications
                'SendEmailViaSMTPComponent'         : FlowIcons.SendEmail,
                'SendEmailViaAwsSesComponent'       : FlowIcons.SendEmail,
                'SendPushViaUrbanAirshipComponent'  : FlowIcons.SendPush,
                'SendSmsComponent'                  : FlowIcons.SendSMS,

                // S3
                'ReadS3Component'               : FlowIcons.ReadS3,
                'ReadS3StreamComponent'         : FlowIcons.ReadS3Stream,
                'WriteS3TextFileComponent'      : FlowIcons.WriteS3,

                // Database
                'ReadDatabaseComponent'         : FlowIcons.ReadDatabase,
                'WriteDatabaseComponent'        : FlowIcons.WriteDatabase,
                'ReadRedshiftComponent'         : FlowIcons.ReadRedshift,
                'WriteRedshiftComponent'        : FlowIcons.WriteRedshift,

                // Database
                'ReadElasticsearchComponent'    : FlowIcons.ReadElasticSearch,
                'WriteElasticsearchComponent'   : FlowIcons.WriteElasticSearch,

                // Web
                'HttpGetComponent'              : FlowIcons.ReadHttp,
                'HttpUpdateComponent'           : FlowIcons.WriteHttp,
                'OAuth2GetComponent'            : FlowIcons.ReadOAuth,
                'OAuth2UpdateComponent'         : FlowIcons.WriteOAuth,
            },
        'mintdata.components:logical-components:0.3.0-SNAPSHOT':
            {
                // Filter
                'BasicFilterComponent'          : FlowIcons.BasicFilter,
                'ExpressionFilterComponent'     : FlowIcons.ExpressionFilter,
                'ScriptFilterComponent'         : FlowIcons.ScriptFilter,

                // Frame Makers
                'FrameFromJsonComponent'         : FlowIcons.JsonToFrame,
                'FrameFromMapComponent'          : FlowIcons.MapToFrame,
                'FrameFromStringComponent'       : FlowIcons.StringToFrame,
                'FrameFromNumberComponent'       : FlowIcons.NumberToFrame,
                'SimpleCounterComponent'         : FlowIcons.SimpleCounter,

                // Transformers ("Frame Import/Exporters?")
                'ParseCSVComponent'              : FlowIcons.CsvToFrame,
                // 'XXX2'                          : FlowIcons.FrameToJson,

                // Operations
                'CombineFramesComponent'        : FlowIcons.CombineFrames,
                'ApplyToEachRowComponent'       : FlowIcons.EachRow,
                'ExtractColumnComponent'        : FlowIcons.ExtractColumn,
                'ExtractColumnsComponent'       : FlowIcons.ExtractColumns,
                'ExtractNestedFramesComponent'  : FlowIcons.ExtractNestedFrames,
                'GroupByComponent'              : FlowIcons.GroupBy,
                'IfComponent'                   : FlowIcons.If,
                'JoinComponent'                 : FlowIcons.Join,
                'SplitColumnsComponent'         : FlowIcons.SplitColumns,
                'SplitRowsComponent'            : FlowIcons.SplitRows,
                'MapComponent'                  : FlowIcons.Map,
                'RegExpComponent'               : FlowIcons.RegExp,

                // Random
                'RandomIntegersComponent'       : FlowIcons.RandomIntegers,
                'RandomWordsComponent'          : FlowIcons.RandomWords,

                // Text
                'TemplatedTextComponent'       : FlowIcons.TemplatedText
            }
    }
}